import { trackExperimentViewed as trackEV } from '@mc/track-event'
import { DECREASE_STANDARD_PRICE_FLAG_NAME } from '../constants'

export const trackExperimentViewed = () => {
  trackEV(DECREASE_STANDARD_PRICE_FLAG_NAME)
}
